import comp from "./AddLE";
export default comp;
